import { render, staticRenderFns } from "./DialogoImpressaoProdutos.vue?vue&type=template&id=e9c6657e&scoped=true&"
import script from "./DialogoImpressaoProdutos.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogoImpressaoProdutos.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c6657e",
  null
  
)

export default component.exports